import { type FC } from "react";
import { useParams } from "react-router-dom";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";
import { PageContentSpinner } from "../../layout/components/PageContentSpinner";
import { LensInsightsPage } from "../../lens-insights/components";
import { DEFAULT_MONETIZATION_TAB } from "../../monetization/models";
import { buildMonetizationTabPath } from "../../monetization/utils";

import { NavigateWithSearch } from "./NavigateWithSearch";
import { type AbsoluteRoute, type RouteParams } from "./absoluteRoutes";
import { RouteEntities } from "./relativeRoutes";

export const InsightsTabRoute: FC = () => {
    const { insightsTab, orgId, lensFolderId } = useParams<RouteParams[AbsoluteRoute.ORG_LENS_FOLDER_INSIGHTS_TAB]>();
    const { loading, configs } = useFeatureGates();

    if (insightsTab !== RouteEntities.Monetization) return <LensInsightsPage />;

    if (loading) return <PageContentSpinner />;

    const isMonetizationHubEnabled = configs[CofConfigId.MyLensesMonetizationInsights].enabled;
    if (isMonetizationHubEnabled) {
        return (
            <NavigateWithSearch
                to={buildMonetizationTabPath({ orgId, lensFolderId, tab: DEFAULT_MONETIZATION_TAB })}
                replace
            />
        );
    }

    return <LensInsightsPage />;
};
